import deepmerge from "deepmerge";
import { isEqual } from "lodash";

/** Merge in Apollo state passed from server or another instance */
function rehydrateApolloState(client: any, state: any) {
  // Get existing cache, loaded during client side data fetching
  const existingCache = client.extract();

  // Merge the existing cache into data passed from getStaticProps/getServerSideProps
  const data = deepmerge(state, existingCache, {
    // combine arrays using object equality (like in sets)
    arrayMerge: (destinationArray, sourceArray) => [
      ...sourceArray,
      ...destinationArray.filter((d) =>
        sourceArray.every((s) => !isEqual(d, s))
      ),
    ],
  });

  // Restore the cache with the merged data
  client.cache.restore(data);
}

export default rehydrateApolloState;
